<!-- client/src/App.vue -->
<template>
  <v-app>
    <NewAquariumModal
      v-if="modalStore.isNewAquariumModalVisible"
      @close="modalStore.closeNewAquariumModal"
    />
    <NewDataLogModal
      v-if="modalStore.isNewDataLogModalVisible"
      @close="modalStore.closeNewDataLogModal"
    />
    <NewUserModal
      v-if="modalStore.isNewUserModalVisible"
      @close="modalStore.closeNewUserModal"
    />
    <main-navbar />
    <sidebar />
    <v-main>
      <router-view />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import MainNavbar from './components/Navigation/MainNavbar.vue';
import Sidebar from './components/Navigation/Sidebar.vue';
import Footer from './components/Navigation/Footer.vue';
import NewAquariumModal from './components/NewAquariumModal.vue';
import NewDataLogModal from './components/NewDataLogModal.vue';
import NewUserModal from '@/components/NewUserModal.vue';
import { useModalStore } from '@/store';

export default {
  name: 'App',
  components: {
    NewAquariumModal,
    NewDataLogModal,
    NewUserModal,
    MainNavbar,
    Sidebar,
    Footer
  },
  setup() {
    const modalStore = useModalStore();

    return {
      modalStore
    };
  },
};
</script>